import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SwiperOptions } from 'swiper';
import { CategoryListService } from './category-deals-list.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { CategoryProducts } from './model/category-products.model';
import { ScreenSizeService } from '../services/screen-size.service';
import { OverlayService } from 'src/app/shared/overlay.service';
import { Renderer2 } from '@angular/core';
import {
    AppliedFilterIds,
    Filter,
    SortLabel,
} from '../filter-data/filter-data.model';
import {
    CurrencyLanguageService,
    LocaleData,
} from '../shared/currency-language.service';
import { DeviceCommsService } from '../services/device-comms.service';
import {
    addFilterIdsToQueryStringAndSearch,
    addSortingDataToQueryString,
} from './category-sort-bar/category-sort-bar.utils';
import {
    addClassToSearchDatesComponent,
    removeClassFromSearchDatesComponent,
} from '../utilities/utils';
import { RouteParamsService } from '../services/route-params.service';
import { screenSizes } from '../utilities/theme';
import { RewardsService } from '../services/rewards.service';
import { BannerImageService } from '../services/banner-image.service';
import { NgbSlideEvent } from '@ng-bootstrap/ng-bootstrap';
import {
    BannerTrackingService,
    BannerPlacement,
} from '../services/banner.service';
import { ProductCardEntry } from '@app/controls/product-card/product-card.model';
import { FilterApplicationService } from '@app/filter-data/filter-application.service';
import { gtmDealClick } from '../utilities/ga.utils';
import { CategoryAllDealsComponent } from './category-all-deals/category-all-deals.component';
import {
    BannerImage,
    BannerSection,
    BannerPlacementEntry,
} from '@app/model/banner.model';
import {
    HOTEL_CATEGORY,
    DAY_PACKAGE_CATEGORY,
    SPA_CATEGORY,
    RESTAURANT_CATEGORY,
    ACTIVITY_CATEGORY,
    RODRIGUES_CATEGORY,
    EVENT_CATEGORY,
    TRAVEL_CATEGORY,
} from '@app/static-content/menu-routes';

declare let $: any;

@Component({
    selector: 'app-category-list',
    templateUrl: './category-deals-list.component.html',
    styleUrls: ['./category-deals-list.component.scss'],
})
export class CategoryListComponent implements OnInit, OnDestroy {
    categoryData: ProductCardEntry[] = [];
    loadingMoreDeals = false;

    @ViewChild('allDeals') allDeals: CategoryAllDealsComponent;

    private boundRedirectToLink: (url: string) => void;
    private subscription: Subscription = Subscription.EMPTY;
    private paramsSubscription: Subscription = Subscription.EMPTY;
    private categoryDealsSubscription: Subscription = Subscription.EMPTY;
    private moreCategoryDealsSubscription: Subscription = Subscription.EMPTY;
    private currencyLanguageSubscription: Subscription = Subscription.EMPTY;
    private rewardPointsSubscription: Subscription = Subscription.EMPTY;
    private filtersSubscription: Subscription = Subscription.EMPTY;
    private bannerSubscription: Subscription = Subscription.EMPTY;
    private isMobileSubscription: Subscription = Subscription.EMPTY;
    private overlayVisibilitySubscription: Subscription = Subscription.EMPTY;
    private eventsSubscription: Subscription = Subscription.EMPTY;

    filterIdsFromQueryString2: AppliedFilterIds[] = [];
    appliedFilterIds2: AppliedFilterIds[] = [];

    banners: Record<string, BannerSection> = {};

    isMobile: boolean = false;

    plpPlacements: { position: string | number; images: BannerImage[] }[] = [];

    private readonly sectionKeyMap: Record<number, string> = {
        [HOTEL_CATEGORY]: 'Stays',
        [DAY_PACKAGE_CATEGORY]: 'dayPackage',
        [SPA_CATEGORY]: 'beautySpa',
        [RESTAURANT_CATEGORY]: 'restaurants',
        [ACTIVITY_CATEGORY]: 'thingsToDo',
        [RODRIGUES_CATEGORY]: 'rodrigues',
        [EVENT_CATEGORY]: 'events',
        [TRAVEL_CATEGORY]: 'travel',
    };

    private capitalise(s: string): string {
        return s ? s.charAt(0).toUpperCase() + s.slice(1) : s;
    }

    filterSortLabel: SortLabel;
    bannerConfig: SwiperOptions = {
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 1,
        autoplay: true,
    };

    totalRecords: number = 0;
    busyLoadingData: boolean = true;

    scrollablePane: Element;
    currencySymbol: 'Rs.' | 'EUR';
    locale: 'en-MU' | 'fr-RE';
    rewardPointsMoney: number = 0;
    localeData: LocaleData;
    urlFilterParams: string;
    filterIds: AppliedFilterIds[] = [];
    topBanner: BannerImage[] = [];
    cardsPerRow: number = 4;

    public sectionId: number;
    public sectionName: string;
    private currentPage = 1;

    constructor(
        public categoryService: CategoryListService,
        public screenSizeService: ScreenSizeService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private currencyLanguageService: CurrencyLanguageService,
        private deviceCommsService: DeviceCommsService,
        private routeParamsService: RouteParamsService,
        private rewardService: RewardsService,
        private overlayService: OverlayService,
        private renderer: Renderer2,
        public bannerService: BannerImageService,
        private bannerTrackingService: BannerTrackingService,
        private filterApplicationService: FilterApplicationService
    ) {
        this.boundRedirectToLink = this.bannerService.redirectToLink.bind(
            this.bannerService
        );
    }

    get areFiltersApplied(): boolean {
        return (
            this.appliedFilterIds2?.length > 0 ||
            this.filterIds?.length > 0 ||
            this.filterIdsFromQueryString2?.length > 0
        );
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
        this.categoryDealsSubscription?.unsubscribe();
        this.moreCategoryDealsSubscription?.unsubscribe();
        this.currencyLanguageSubscription?.unsubscribe();
        this.rewardPointsSubscription?.unsubscribe();
        this.filtersSubscription?.unsubscribe();
        this.isMobileSubscription?.unsubscribe();
        this.overlayVisibilitySubscription?.unsubscribe();
        this.eventsSubscription?.unsubscribe();
    }

    ngOnInit(): void {
        document.body.scrollTop = 0;
        this.scrollablePane = document.getElementsByClassName('pane')[0];
        this.currencyLanguageService.getCurrency().subscribe((currency) => {
            this.currencySymbol = currency;
        });
        this.currencyLanguageSubscription = this.currencyLanguageService
            .getLocaleForCurrency()
            .subscribe((locale) => {
                this.locale = locale;
            });
        this.rewardPointsSubscription =
            this.rewardService.rewardsPoints$.subscribe((rewards) => {
                if (rewards) {
                    this.rewardPointsMoney = rewards.rewardPointsMoney;
                }
            });
        this.filtersSubscription =
            this.filterApplicationService.$filterSubject.subscribe((filters) =>
                this.applyFilters(filters)
            );
        addClassToSearchDatesComponent();

        this.eventsSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.appliedFilterIds2 = [];
            }
        });
        this.subscribeToResponsiveCardsPerRow();

        this.urlFilterParams = this.activatedRoute.queryParams['filters'];

        this.subscription = combineLatest([
            this.bannerService.getBanners<BannerSection>('plp'),
            this.activatedRoute.params,
        ]).subscribe(([banners, params]) => {
            const rawSectionId = Number(params['sectionId']);
            const rawSectionName = params['sectionName'];

            if (!rawSectionId || isNaN(rawSectionId) || !rawSectionName) {
                return; //  Prevent bad request
            }

            this.banners = banners;
            this.sectionId = rawSectionId;
            this.sectionName = this.capitalise(rawSectionName);
            this.routeParamsService.setSectionId(this.sectionId);
            this.loadPlpPlacements();

            this.getCategoryData();
        });

        this.isMobileSubscription =
            this.screenSizeService.isMobileWidth.subscribe((mobile) => {
                this.isMobile = mobile;
            });

        this.overlayVisibilitySubscription =
            this.overlayService.overlayVisible$.subscribe(
                (isVisible: boolean) => {
                    const mdCategoryListingsRow = document.querySelector(
                        '.md-category-listings'
                    );
                    if (mdCategoryListingsRow) {
                        const childrenArray = Array.from(
                            mdCategoryListingsRow.children
                        );
                        childrenArray.forEach((child: Element) => {
                            this.renderer.setStyle(
                                child,
                                'pointer-events',
                                isVisible ? 'none' : 'auto'
                            );
                            this.renderer.setStyle(
                                child,
                                'filter',
                                isVisible ? 'blur(1.6px)' : 'none'
                            );
                        });
                    }

                    const appFilterData = document.querySelector('.row');
                    if (appFilterData) {
                        this.renderer.setStyle(
                            appFilterData,
                            'pointer-events',
                            isVisible ? 'none' : 'auto'
                        );
                        this.renderer.setStyle(
                            appFilterData,
                            'filter',
                            isVisible ? 'blur(1.6px)' : 'none'
                        );
                    }
                }
            );
    }

    private screenReady = false;
    private dealsReady = false;

    private subscribeToResponsiveCardsPerRow(): void {
        this.isMobileSubscription =
            this.screenSizeService.screenWidth.subscribe((width) => {
                if (width <= screenSizes.mobile) {
                    this.cardsPerRow = 1;
                } else if (width < screenSizes.desktop) {
                    this.cardsPerRow = 3;
                } else if (width < screenSizes.largeDesktop) {
                    this.cardsPerRow = 4;
                } else {
                    this.cardsPerRow = 5;
                }
                this.screenReady = true;
                this.tryComputeRows();
            });
    }
    private isBannerPlacement(obj: any): obj is BannerPlacement {
        return (
            obj &&
            typeof obj === 'object' &&
            'placements' in obj &&
            Array.isArray(obj['placements'])
        );
    }

    private getPlpPlacements(sectionId: number): BannerPlacementEntry[] {
        const sectionKey = this.sectionKeyMap[sectionId];
        const section = this.banners?.[sectionKey];

        if (this.isBannerPlacement(section)) {
            return (section as BannerPlacement)['placements']; // ✅ cast + bracket access
        }

        return [];
    }
    private loadPlpPlacements(): void {
        const placements = this.getPlpPlacements(this.sectionId);
        this.plpPlacements = placements;
        this.topBanner =
            placements.find((p) => p.position === 'top')?.images ?? [];
    }
    private computeProductRows(): void {
        const rows: ProductCardEntry[][] = [];
        for (let i = 0; i < this.categoryData.length; i += this.cardsPerRow) {
            rows.push(this.categoryData.slice(i, i + this.cardsPerRow));
        }
        this.productRows = rows;
    }

    trackByProduct(index: number, item: ProductCardEntry): number {
        return item.id;
    }

    trackByRow(index: number, row: ProductCardEntry[]): number {
        // Optional optimization: return the ID of the first product in the row
        return row[0]?.id || index;
    }
    handleBannerClick(bannerKey: string, idx: number): void {
        const flatBannerMap = this.plpPlacements.reduce((acc, placement) => {
            acc[placement.position] = placement;
            return acc;
        }, {} as Record<string, { images: BannerImage[] }>);

        this.bannerTrackingService.handleBannerClick(
            bannerKey,
            idx,
            flatBannerMap,
            this.boundRedirectToLink,
            'plp'
        );
    }
    handleBannerImpression(index: number, bannerKey: string): void {
        const flatBannerMap = this.plpPlacements.reduce((acc, placement) => {
            acc[placement.position] = placement;
            return acc;
        }, {} as Record<string, { images: BannerImage[]; activeIndex?: number }>);

        this.bannerTrackingService.handleBannerImpression(
            index,
            bannerKey,
            flatBannerMap
        );
    }

    onBannerSlide(event: NgbSlideEvent, bannerKey: string): void {
        const flatBannerMap = this.plpPlacements.reduce((acc, placement) => {
            acc[placement.position] = placement;
            return acc;
        }, {} as Record<string, { images: BannerImage[]; activeIndex?: number }>);

        this.bannerTrackingService.onBannerSlide(
            event,
            bannerKey,
            flatBannerMap
        );
    }
    productRows: ProductCardEntry[][] = [];

    getProductChunks(): ProductCardEntry[][] {
        const chunks: ProductCardEntry[][] = [];
        for (let i = 0; i < this.categoryData.length; i += 4) {
            chunks.push(this.categoryData.slice(i, i + 4));
        }
        return chunks;
    }
    getBannerAfterRow(rowIdx: number): BannerImage[] | null {
        const width = this.screenSizeService.currentScreenWidth;

        let cardsPerRow: number;
        let jsonGroupSize = 4; // always based on JSON format
        let triggerEvery = 4; // how often we show the banner visually

        if (width <= screenSizes.mobile) {
            cardsPerRow = 1;
            triggerEvery = 4;
        } else if (width < screenSizes.desktop) {
            cardsPerRow = 3;
            triggerEvery = 3;
        } else if (width < screenSizes.largeDesktop) {
            cardsPerRow = 4;
            triggerEvery = 4;
        } else {
            cardsPerRow = 5;
            triggerEvery = 5;
        }

        const productIndexAfterRow = (rowIdx + 1) * cardsPerRow;

        let normalizedIndex: number;

        if (width <= screenSizes.mobile) {
            // Only show banner after 4 cards
            if (productIndexAfterRow % triggerEvery !== 0) return null;
            normalizedIndex = productIndexAfterRow;
        } else {
            // Map visual grouping (5) to data grouping (4): after 5 → after-4
            if (productIndexAfterRow % triggerEvery !== 0) return null;
            normalizedIndex =
                Math.ceil(productIndexAfterRow / triggerEvery) * jsonGroupSize;
        }

        const placementKey = `after-${normalizedIndex}`;

        return (
            this.plpPlacements.find((p) => p.position === placementKey)
                ?.images ?? null
        );
    }

    getBannerAfter(index: number): BannerImage[] | null {
        const placementKey = `after-${index}`;
        return (
            this.plpPlacements.find((p) => p.position === placementKey)
                ?.images ?? null
        );
    }
    private getFilterIdsFromParamsAndFilterComponent(): AppliedFilterIds[] {
        return this.appliedFilterIds2.length > 0
            ? this.appliedFilterIds2
            : this.filterIdsFromQueryString2;
    }

    private parseFilterParams(filterParams: string): AppliedFilterIds[] {
        return filterParams
            ? filterParams.split(',').map((filter) => {
                  const [filterTypeId, filterId] = filter.split('-');
                  return {
                      filterTypeId: +filterTypeId,
                      filterId: +filterId,
                  };
              })
            : [];
    }
    getPlacement(position: string | number): BannerImage[] | null {
        return (
            this.plpPlacements.find((p) => p.position === position)?.images ??
            null
        );
    }
    private tryComputeRows(): void {
        if (this.screenReady && this.dealsReady) {
            this.computeProductRows();
        }
    }

    getCategoryData() {
        this.subscription = combineLatest([
            this.activatedRoute.params,
            this.activatedRoute.queryParams,
            this.currencyLanguageService.getLocaleData(),
        ]).subscribe(([_, queryParams, locale]) => {
            this.busyLoadingData = true;

            const filterParams: string = queryParams['filters'];
            this.urlFilterParams = filterParams;
            this.filterIdsFromQueryString2 =
                this.parseFilterParams(filterParams);

            const sortParam: string = queryParams['sort'];
            if (sortParam) {
                this.filterSortLabel = sortParam as SortLabel;
            }

            const filterIdsToApply =
                this.getFilterIdsFromParamsAndFilterComponent();
            this.localeData = locale;

            this.categoryDealsSubscription = this.categoryService
                .getCategoryDetails(
                    filterIdsToApply,
                    this.filterSortLabel,
                    locale.language,
                    this.sectionId,
                    locale.country
                )
                .subscribe({
                    next: (response: CategoryProducts) => {
                        this.busyLoadingData = false;
                        this.totalRecords = response.total;
                        this.categoryData = [...response.data];
                        this.dealsReady = true;
                        this.tryComputeRows();
                        this.filterApplicationService.changeNrOfResults(
                            this.totalRecords
                        );

                        if (this.categoryService.scrollPosition) {
                            setTimeout(() => {
                                this.scrollablePane.scrollTop =
                                    this.categoryService.scrollPosition;
                            }, 0);
                        }
                    },
                });
        });
    }

    onScroll() {
        if (this.busyLoadingData) return;

        if (this.categoryData.length < this.totalRecords) {
            this.loadingMoreDeals = true;
            this.currentPage += 1;

            this.filterIds = this.parseFilterParams(this.urlFilterParams);

            this.moreCategoryDealsSubscription = this.categoryService
                .getMoreCategoryDetails(
                    this.currentPage,
                    this.filterIds,
                    this.filterSortLabel,
                    this.localeData.language,
                    this.sectionId,
                    this.localeData.country
                )
                .subscribe({
                    next: (response: CategoryProducts) => {
                        this.categoryData.push(...response.data);
                        this.computeProductRows();
                        this.loadingMoreDeals = false;
                    },
                });
        } else if (
            this.allDeals?.categoryData?.length < this.allDeals?.totalRecords
        ) {
            this.allDeals.onScroll();
        }
    }

    applyFilters(filters: Filter[]) {
        this.appliedFilterIds2 =
            filters?.flatMap((f) =>
                f.filterValues.map((fv) => ({
                    filterTypeId: f.filterTypeId,
                    filterId: fv.filterId,
                }))
            ) || [];

        addFilterIdsToQueryStringAndSearch(this.router, this.appliedFilterIds2);
        this.currentPage = 1;
    }

    applySorting(sortLabel: SortLabel) {
        this.filterSortLabel = sortLabel;
        addSortingDataToQueryString(this.router, sortLabel);
        this.currentPage = 1;
    }

    onImageError(event: any) {
        event.target.src = 'assets/img/defaultIcon.png';
    }

    redirectToProdDetail(id: number, productPath: string, name: string) {
        gtmDealClick(id, name, this.sectionName);
        this.categoryService.scrollPosition = this.scrollablePane.scrollTop;
        this.deviceCommsService.openLinkInNewTabIfBrowser(
            `/deal/${productPath}/${id}`
        );
    }

    goToPromotionLink(link: string) {
        this.deviceCommsService.openLinkInNewTabOrBrowser(link);
    }

    onParentDivClick(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();
    }

    onImageClick(event: MouseEvent) {
        event.stopPropagation();
    }
}
